import React from "react";
import Modal from "./";
import { useAtomValue } from "jotai/utils";
import {
  globalSaloonMemberProfileViewerPropsAtom,
  useCloseGlobalSaloonMemberProfileViewer,
} from "./atoms/globalModal";

const GlobalSaloonMemberProfileModal = () => {
  const props = useAtomValue(globalSaloonMemberProfileViewerPropsAtom);
  const close = useCloseGlobalSaloonMemberProfileViewer();
  return <Modal {...props} onClose={close} />;
};

export default GlobalSaloonMemberProfileModal;
